import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Login.vue')
    },
    {
      path: '/home',
      name: 'Home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Home.vue')
    },
    {
      path: '/',
      name: 'index',
      component: () => import('./views/Index.vue'),
      children: [
        {
          path: '/usercenter',
          name: 'UserCenter',
          component: () => import('./views/UserCenter.vue')
        },
        {
          path: '/fenghuang',
          name: 'Fenghuang',
          component: () => import('./views/Fenghuang.vue')
        },
        {
          path: '/apply',
          name: 'Apply',
          component: () => import('./views/Apply.vue')
        },
        {
          path: '/public/inform',
          name: 'inform',
          component: () => import('./views/Public/Inform/Inform.vue'),
        },
        {
          path:'/public/inform/publish',
          name:'informPublish',
          component: () => import('./views/Public/Inform/Publish.vue'),

        },
        {
          path:'/public/bussiness',
          name:'business',
          component: () => import('./views/Public/Bussiness/Bussiness.vue'),
        },
        {
          path:'/public/template',
          name:'template',
          component: () => import('./views/Public/Template/Template.vue'),
        },
        {
          path:'/public/attendance',
          name:'attendance',
          component: () => import('./views/Public/Attendance/Attendance.vue'),
        },
        {
          path:'/public/process',
          name:'process',
          component: () => import('./views/Public/Process/Process.vue'),
        },
        {
          path:'/usermanagement/user',
          name:'user',
          component: () => import('./views/UserManagement/User.vue'),
        },
        {
          path:'/usermanagement/limit',
          name:'limit',
          component: () => import('./views/UserManagement/Limit.vue'),
        },
        {
          path:'/usermanagement/office',
          name:'office',
          component: () => import('./views/UserManagement/Office.vue'),
        },
        {
          path:'/message',
          name:'message',
          component: () => import('./views/Message/Message.vue'),
        },
        {
          path:'/message/readmessage/:id',
          name:'readmessage',
          component: () => import('./views/Message/ReadMessage.vue'),
        },
        {
          path:'/public/inform/readmessage/:id',
          name:'vipreadmessage',
          component: () => import('./views/Public/Inform/ReadMessage.vue'),
        },
        {
          path:'/ch_channel/bussiness',
          name:'chBussiness',
          component: () => import('./views/ChineseChannel/Bussiness.vue'),
        },
        {
          path:'/ch_channel/check',
          name:'chCheck',
          component: () => import('./views/ChineseChannel/Check.vue'),
        },
        {
          path:'/ch_channel/detail/:id',
          name:'chDetail',
          component: () => import('./views/ChineseChannel/Detail.vue'),
        },
        {
          path:'/data/static',
          name:'static',
          component: () => import('./views/Data/Static.vue'),
        },
        {
          path:'/data/csm',
          name:'csm',
          component: () => import('./views/Data/CSM.vue'),
        },
        {
          path:'/data/progress',
          name:'progress',
          component: () => import('./views/Data/Progress.vue'),
        },
        {
          path:'/information',
          name:'information',
          component: () => import('./views/Information.vue'),
        },
        {
          path:'/mv_channel/bussiness',
          name:'movieChannel',
          component: () => import('./views/MovieChannel/Bussiness.vue'),
        },
        {
          path:'/mv_channel/ex-contract',
          name:'exContract',
          component: () => import('./views/MovieChannel/ExContract.vue'),
        },
        {
          path:'/mv_channel/agent',
          name:'mvAgent',
          component: () => import('./views/MovieChannel/Agent.vue'),
        },
        {
          path:'/mv_channel/client',
          name:'mvClient',
          component: () => import('./views/MovieChannel/Client.vue'),
        },
        {
          path:'/mv_channel/signmoney',
          name:'mvSignmoney',
          component: () => import('./views/MovieChannel/SignMoney.vue'),
        },
        {
          path:'/mv_channel/paymoney',
          name:'mvPaymoney',
          component: () => import('./views/MovieChannel/PayMoney.vue'),
        },
        {
          path:'/mv_channel/contract_stats',
          name:'mvContractstats',
          component: () => import('./views/MovieChannel/ContractStats.vue'),
        },
        {
          path:'/mv_channel/detail/:id',
          name:'mvDetail',
          component: () => import('./views/MovieChannel/Detail.vue'),
        },
        {
          path:'/mv_channel/agent_detail/:id',
          name:'agentDetal',
          component: () => import('./views/MovieChannel/AgentDetail.vue'),
        }
      ]
    }
  ],
})
